
export enum InterviewType {
    AiScreening = "AiScreening",
    ExpertSession = "ExpertSession",
    VideoScreening = "VideoScreening",
}